"use strict";var o=(i=>(i.None="None",i.Positive="Positive",i.Critical="Critical",i.Negative="Negative",i.Information="Information",i))(o||{});export default o;
//# sourceMappingURL=ValueState.js.map
